<template>
  <div :class="className" role="alert">
    <slot />
  </div>
</template>

<script>
export default {
  name: "AlertBox",
  props: {
    type: {
      type: String,
      default: "success"
    }
  },
  computed: {
    className() {
      return `alert alert-${this.type}`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
